if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
  document.body.classList.add("safari");
}

const cartDrawer = document.getElementById("cart-drawer");
const cartDrawerSectionId = cartDrawer.getAttribute("data-section-id");
const nonaHeader = document.getElementById("header-nona");
const nonaHeaderSectionId = nonaHeader.getAttribute("data-section-id");

let busyUpdating = false;
const replaceSection = (sectionId, content, updateId) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(content, "text/html");
  document.getElementById(
    updateId || "shopify-section-" + sectionId,
  ).innerHTML = doc.getElementById(
    updateId || "shopify-section-" + sectionId,
  ).innerHTML;
};

const addToCart = async (
  button,
  variantId,
  quantity = 1,
  isFreeProduct = false,
  customProperties = {},
) => {
  // TODO
  if (
    document.body.classList.contains("offer") &&
    variantId.toString() === "55800164024655"
  ) {
    quantity = quantity * 2;
  }
  let originalText = "";
  // Show a loading state on the button
  if (button) {
    originalText = button.textContent;
    button.querySelector("span").textContent =
      button.getAttribute("data-adding") || "Adding...";
    button.disabled = true;
    button.classList.add("loading");
  }

  const formData = {
    items: [
      {
        id: variantId,
        quantity,
        properties: isFreeProduct
          ? { _free_product: "true", ...customProperties }
          : Object.keys(customProperties).length > 0
            ? customProperties
            : undefined,
      },
    ],
    sections: [cartDrawerSectionId, nonaHeaderSectionId],
  };

  const response = await fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  });
  if (!response.ok) {
    openNonaModal(window.nona.strings.errorAddingToCart);
    console.error("Error adding to cart:", error);
    if (button) {
      button.querySelector("span").textContent = originalText;
      button.disabled = false;
      button.classList.remove("loading");
    }
    return;
  }
  const data = await response.json();
  const currentCartJson = await fetch(window.Shopify.routes.root + "cart.js");
  const currentCart = await currentCartJson.json();

  data.total_price = currentCart.total_price;
  data.items = currentCart.items;

  //

  console.log("dataa", data, currentCart);
  // toast(
  //   window.nona.strings.addedToCart.replace("XXX", data.items[0].title),
  //   "success"
  // );

  await updateCartJS(data, true);
  if (button) {
    button.querySelector("span").textContent = originalText;
    button.disabled = false;
    button.classList.remove("loading");
  }
};

const removeCartItem = async (lineItemId, quantity, giftbox, button) => {
  if (busyUpdating) return;
  busyUpdating = true;

  if (button) {
    button.disabled = true;
    button.classList.add("loading");
  }

  const updates = {
    [lineItemId]: 0,
  };

  console.log("Removing item:", lineItemId);

  fetch(window.Shopify.routes.root + "cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      updates: updates,
      sections: [cartDrawerSectionId, nonaHeaderSectionId],
    }),
  })
    .then((response) => {
      return response.json();
    })
    .then(async (data) => {
      console.log("Item removed:", data);
      busyUpdating = false;
      if (button) {
        button.disabled = false;
        button.classList.remove("loading");
      }
      await updateCartJS(data);
    })
    .catch((error) => {
      busyUpdating = false;
      if (button) {
        button.disabled = false;
        button.classList.remove("loading");
      }
      console.error("Error:", error);
    });
};

const checkFreeProduct = async (
  threshold,
  freeProductId,
  cartItems,
  cartTotal,
) => {
  console.log(
    parseInt(threshold),
    freeProductId,
    cartItems,
    parseInt(cartTotal.toString()),
  );
  // Get threshold and free product id from data attributes or inline JSON
  if (!freeProductId) {
    console.log("No free product set");
    const freeProductsInCart = getOldFreeProductsInCart();
    if (freeProductsInCart.length > 0) {
      console.log(
        "Free product(s) found in cart but no free product set. Removing free products.",
      );
      // Remove all free products
      for (let i = 0; i < freeProductsInCart.length; i++) {
        await removeCartItem(freeProductsInCart[i].key, 1, false, null);
      }
    }
    return;
  }

  function isFreeProductInCart() {
    console.log("cartItems", cartItems);
    return cartItems.some(function (item) {
      return (
        item.variant_id.toString() === freeProductId.toString() &&
        item.properties &&
        item.properties._free_product === "true"
      );
    });
  }

  function getOldFreeProductsInCart() {
    return cartItems.filter(function (item) {
      return item.properties && item.properties._free_product === "true";
    });
  }
  function getAllFreeProductsInCart() {
    return cartItems.filter(function (item) {
      return (
        item.variant_id.toString() === freeProductId.toString() &&
        item.properties &&
        item.properties._free_product === "true"
      );
    });
  }

  function getFreeProductLineItemId() {
    const freeProduct = cartItems.find(function (item) {
      return (
        item.variant_id.toString() === freeProductId.toString() &&
        item.properties &&
        item.properties._free_product === "true"
      );
    });
    return freeProduct ? freeProduct.key : null;
  }

  function isOverThreshold() {
    return parseInt(cartTotal.toString()) >= parseInt(threshold.toString());
  }

  // Don't prevent execution if busy - queue it instead for important free product logic
  if (busyUpdating) {
    console.log("Free product check delayed due to busy updating");
    setTimeout(() => {
      checkFreeProduct(threshold, freeProductId, cartItems, cartTotal);
    }, 500);
    return;
  }

  // Check for multiple free products and remove extras
  const allFreeProducts = getAllFreeProductsInCart();
  if (allFreeProducts.length > 1) {
    console.log("Multiple free products found, removing extras");
    // Remove all but the first one
    for (let i = 1; i < allFreeProducts.length; i++) {
      await removeCartItem(allFreeProducts[i].key, 1, false, null);
    }
  }

  if (isOverThreshold()) {
    if (isFreeProductInCart()) {
      console.log(
        "Cart is over threshold and free product is already included.",
      );
    } else {
      console.log(
        "Cart is over threshold but free product is NOT included. Adding free product...",
      );
      try {
        await addToCart(null, freeProductId, 1, true);
      } catch (error) {
        console.error("Failed to add free product:", error);
        // Retry once after a short delay
        setTimeout(async () => {
          try {
            await addToCart(null, freeProductId, 1, true);
          } catch (retryError) {
            console.error("Retry failed to add free product:", retryError);
          }
        }, 1000);
      }
    }
  } else {
    if (isFreeProductInCart()) {
      const lineItemId = getFreeProductLineItemId();
      if (lineItemId) {
        await removeCartItem(lineItemId, 1, false, null);
        console.log("Cart is NOT over threshold but free product is included.");
      }
    } else {
      console.log(
        "Cart is NOT over threshold and free product is NOT included.",
      );
    }
  }
};

const refreshCartSections = async () => {
  const response = await fetch(window.Shopify.routes.root + "cart/update.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      updates: {},
      sections: [cartDrawerSectionId, nonaHeaderSectionId],
    }),
  });
  const data = await response.json();
  await updateCartJS(data);
};

const updateCartJS = async (data, clickFromOutside = false) => {
  replaceSection(cartDrawerSectionId, data.sections[cartDrawerSectionId]);
  replaceSection(
    nonaHeaderSectionId,
    data.sections[nonaHeaderSectionId],
    "cart-icon",
  );

  setupHeaderFunctionality(true);
  if (clickFromOutside) {
    setTimeout(() => {
      toggleCartDrawer();
    }, 0);
  } else {
    toggleCartDrawer();
  }
  // Reset button state
  hookUpAmountChangeListeners();
  hookUpAddToCartListeners("#cart-drawer");

  console.log("data", data);

  document.dispatchEvent(
    new CustomEvent("nona:cart:updated", { detail: data }),
  );

  const threshold = document.body.dataset.threshold;
  const freeProductId = document.body.dataset.freeProductId;
  await checkFreeProduct(
    threshold,
    freeProductId,
    data.items,
    data.total_price,
  );
};

const toggleCartDrawer = (forceClose = false) => {
  const cartDrawer = document.getElementById("cart-drawer");

  if (forceClose) {
    cartDrawer.classList.remove("show");
  } else {
    cartDrawer.classList.toggle("show");
  }
};

const hookUpAddToCartListeners = (classId = "body") => {
  const allAddToCartButtons = document
    .querySelector(classId)
    .querySelectorAll('[data-action="add-to-cart"]');

  allAddToCartButtons.forEach((button) => {
    if (!button.hasAttribute("data-listener-added")) {
      button.addEventListener("click", (event) => {
        event.preventDefault();
        const productId = button.getAttribute("data-product-id");
        //TODO: this does not work
        button.setAttribute("data-listener-added", "true");
        const quantityInput = document.getElementById("quantity-product");
        const quantity = quantityInput ? parseInt(quantityInput.value, 10) : 1;
        const giftboxInput = document.getElementById("giftbox-input");
        const withGiftBox = giftboxInput ? giftboxInput.checked : false;
        const giftboxId = giftboxInput?.dataset.giftbox;
        if (withGiftBox) {
          addToCart(button, giftboxId, quantity);
        } else {
          addToCart(button, productId, quantity);
        }
      });
    }
  });
};

hookUpAmountChangeListeners = () => {
  const allDecreaseButtons = document.querySelectorAll(
    '[data-action="decrease-quantity"]',
  );
  const allIncreaseButtons = document.querySelectorAll(
    '[data-action="increase-quantity"]',
  );

  const allRemoveFromCartButtons = document.querySelectorAll(
    '[data-action="remove-from-cart"]',
  );

  allRemoveFromCartButtons.forEach((button) => {
    button.addEventListener("click", async (event) => {
      event.preventDefault();
      event.stopPropagation();
      const lineItemId = button.dataset.lineItemId;
      const giftbox = button.dataset.giftbox;
      const quantity = button.dataset.quantity;
      removeCartItem(lineItemId, quantity, giftbox, button);
    });
  });

  const allQuantityInputs = document.querySelectorAll("[data-line-item-id]");

  allDecreaseButtons.forEach((button) => {
    if (!button.hasAttribute("data-listener-added")) {
      button.addEventListener("click", (event) => {
        event.preventDefault();
        const input = button.nextElementSibling;
        let currentValue = parseInt(input.value, 10);

        if (input.getAttribute("min") == "1") {
          if (currentValue > 1) {
            input.value = currentValue - 1;
            input.dispatchEvent(new Event("change"));
          }
          return;
        }

        if (currentValue > 0) {
          input.value = currentValue - 1;
          input.dispatchEvent(new Event("change"));
        }
      });
      button.setAttribute("data-listener-added", "true");
    }
  });
  allIncreaseButtons.forEach((button) => {
    if (!button.hasAttribute("data-listener-added")) {
      button.addEventListener("click", (event) => {
        event.preventDefault();
        const input = button.previousElementSibling;
        let currentValue = parseInt(input.value, 10);
        input.value = currentValue + 1;
        input.dispatchEvent(new Event("change"));
      });
      button.setAttribute("data-listener-added", "true");
    }
  });

  allQuantityInputs.forEach((input) => {
    //update quantity
    let debounceTimer;

    input.addEventListener("change", async (e) => {
      clearTimeout(debounceTimer);
      input.classList.add("loading");
      debounceTimer = setTimeout(async () => {
        if (busyUpdating) return;
        busyUpdating = true;
        const lineItemId = input.dataset.lineItemId;
        if (!lineItemId) {
          // we also have quantity input on product detail page.
          // this does not need to update the cart.
          busyUpdating = false;
          return;
        }
        let updates;
        console.log(lineItemId, e.target.value);
        if (
          document.body.classList.contains("offer") &&
          lineItemId.toString() === "55800164024655"
        ) {
          const previousCartJson = await fetch(
            window.Shopify.routes.root + "cart.js",
          );
          const previousCart = await previousCartJson.json();
          const difference =
            parseInt(e.target.value) -
            previousCart.items.find(
              (i) => i.id.toString() === lineItemId.toString(),
            ).quantity;
          console.log(difference);
          updates = {
            [lineItemId]: parseInt(e.target.value) + difference,
          };
        } else {
          updates = {
            [lineItemId]: parseInt(e.target.value),
          };
        }

        fetch(window.Shopify.routes.root + "cart/update.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            updates,
            sections: [cartDrawerSectionId, nonaHeaderSectionId],
          }),
        })
          .then((response) => {
            return response.json();
          })
          .then(async (data) => {
            await updateCartJS(data);
            busyUpdating = false;
            input.classList.remove("loading");
          })
          .catch((error) => {
            busyUpdating = false;
            input.classList.remove("loading");
            console.error("Error:", error);
          });
      }, 500);
    });
  });
};

hookUpAmountChangeListeners();
hookUpAddToCartListeners();
// const header = document.querySelector("#header-group");

// const observer = new IntersectionObserver(
//   ([entry]) => {
//     console.log("window.scrollY", window.scrollY)
//     if (entry.isIntersecting && window.scrollY === 0) {
//       header.classList.remove("sticky");
//     } else {
//       header.classList.add("sticky");
//     }
//   },
//   {
//     threshold: [0],
//   }
// );

// if (header) {
//   observer.observe(header);
// }

// window.addEventListener("scroll", () => {
//   if (header) {
//     if (header.getBoundingClientRect().top === 0 && window.scrollY === 0) {
//       header.classList.remove("sticky");
//     } else if (!header.classList.contains("sticky")) {
//       header.classList.add("sticky");
//     }
//   }
// });

document.addEventListener("DOMContentLoaded", function () {
  setupHeaderFunctionality();

  if (window.location.hash === "#cart") {
    toggleCartDrawer();
    history.replaceState(
      null,
      "",
      window.location.pathname + window.location.search,
    );
  }
});

const setupHeaderFunctionality = (preventHeader) => {
  const cartIcon = document.getElementById("cart-icon");
  const cartDrawer = document.getElementById("cart-drawer");
  const cartOverlay = document.querySelector(".cart-overlay");
  const closeCartButton = document.querySelector(".close-cart-button");

  cartIcon.href = "#";

  cartIcon.setAttribute("aria-haspopup", "true");
  cartIcon.setAttribute("aria-expanded", "false");
  cartDrawer.setAttribute("aria-hidden", "true");
  cartDrawer.setAttribute("role", "dialog");
  cartDrawer.addEventListener("transitionend", function () {
    if (cartDrawer.classList.contains("show")) {
      cartDrawer.setAttribute("aria-hidden", "false");
    } else {
      cartDrawer.setAttribute("aria-hidden", "true");
    }
  });

  cartOverlay.addEventListener("click", function () {
    toggleCartDrawer(true);
  });
  closeCartButton.addEventListener("click", function (event) {
    event.preventDefault();
    toggleCartDrawer(true);
  });
  if (preventHeader) {
  } else {
    cartIcon.addEventListener("click", function (event) {
      event.preventDefault();
      toggleCartDrawer();
    });
  }
};
const modal = document.getElementById("nona-modal");

modal.addEventListener("click", () => modal.close());

const myDiv = document.getElementById("inner-modal");
myDiv.addEventListener("click", (event) => event.stopPropagation());

const openNonaModal = (message) => {
  const modalBody = modal.querySelector(".nona-modal-body");
  modalBody.textContent = message;
  modal.showModal();
};
const setupCocktailLikeButtons = () => {
  const buttons = document.querySelectorAll(".btn-favorite-cocktail");
  buttons.forEach((button) => {
    button.addEventListener("click", async (event) => {
      event.preventDefault();
      event.stopPropagation();
      const cocktailId = button.getAttribute("data-id");
      let customerId = button.getAttribute("data-customer-id");

      if (!customerId) {
        openNonaModal(window.nona.strings.cocktailsOnlyForCustomers);
        return;
      }
      console.log("Toggle favorite for cocktail:", cocktailId, customerId);
      button.classList.toggle("liked");
      const isLocalhost =
        location.hostname === "localhost" || location.hostname === "127.0.0.1";

      const apiUrl = isLocalhost
        ? `http://localhost:8080`
        : "https://nona-server-418706328134.europe-west1.run.app";

      const isFavorite = button.classList.contains("liked");
      const x = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          customerId,
          cocktailId,
          isFavorite,
        }),
      });

      if (!x.ok) {
        openNonaModal(window.nona.strings.somethingWentWrong);
      } else {
        toast(
          isFavorite
            ? window.nona.strings.cocktailLiked
            : window.nona.strings.cocktailUnliked,
        );
      }
    });
  });
};
setupCocktailLikeButtons();

const toast = (message, type = "info", duration = 3000) => {
  const toastElement = document.createElement("div");
  toastElement.className = `toast ${type}`;
  toastElement.textContent = message;
  document.body.appendChild(toastElement);
  setTimeout(() => {
    toastElement.remove();
  }, duration);
};

const setupShareButtons = () => {
  const buttons = document.querySelectorAll(".share-button");
  buttons.forEach((button) => {
    button.addEventListener("click", (event) => {
      event.preventDefault();
      if (navigator.share) {
        navigator
          .share({
            title: document.title,
            url: window.location.href,
          })
          .catch((error) => {
            console.error("Error sharing:", error);
          });
      } else {
        navigator.clipboard.writeText(window.location.href).catch((err) => {
          console.error("Failed to copy:", err);
        });
        toast(window.nona.strings.copied);
      }
    });
  });
};
setupShareButtons();

const setupFilterClicks = () => {
  const filters = document.querySelectorAll(".nona-filter");
  filters.forEach((filter) => {
    filter.addEventListener("click", (event) => {
      const scrollY = window.scrollY || window.pageYOffset;
      localStorage.setItem("nona-scroll-position", scrollY);
    });
  });
};
setupFilterClicks();

const changeBundleTaste = (urlToNavigate) => {
  console.log("Navigating to:", urlToNavigate);
  const scrollY = window.scrollY || window.pageYOffset;
  localStorage.setItem("nona-scroll-position", scrollY);

  window.location.href = urlToNavigate;
};

const setupClickPreviewImages = () => {
  const previewButtons = document.querySelectorAll("[data-big-image]");
  previewButtons.forEach((button) => {
    button.addEventListener("click", (event) => {
      const mainImage = document.querySelector(".main-image img");
      mainImage.classList.add("blurry");
      // set blurry small image
      mainImage.src = button.querySelector("img").src;
      mainImage.srcset = button.querySelector("img").srcset;

      const bigImageUrl = button.getAttribute("data-big-image");
      const bigImageSrcSet = button.getAttribute("data-big-image-src-set");

      mainImage.src = bigImageUrl;
      mainImage.srcset = bigImageSrcSet;

      mainImage.onload = () => {
        mainImage.classList.remove("blurry");
      };
    });
  });
};
setupClickPreviewImages();
const goToNextImage = () => {
  const mainImage = document.querySelector(".main-image img");
  const previewImages = document.querySelectorAll(".previews button");
  const currentSrc = mainImage.src;
  const currentIndex = Array.from(previewImages).findIndex((img) =>
    currentSrc.includes(img.dataset.bigImage),
  );
  const nextIndex = (currentIndex + 1) % previewImages.length;
  previewImages[nextIndex].click();
};

const goToPreviousImage = () => {
  // Left side: go to previous image
  const previewImages = document.querySelectorAll(".previews button");
  const currentSrc = mainImage.src;
  const currentIndex = Array.from(previewImages).findIndex((img) =>
    currentSrc.includes(img.dataset.bigImage),
  );
  const prevIndex =
    (currentIndex - 1 + previewImages.length) % previewImages.length;
  previewImages[prevIndex].click();
};
const mainImage = document.querySelector(".main-image img");
if (mainImage) {
  const autoscroll = false;
  if (autoscroll) {
    setInterval(() => {
      goToNextImage();
    }, 5000);
  }
  mainImage.addEventListener("click", () => {
    const rect = mainImage.getBoundingClientRect();
    const clickX = event.clientX - rect.left;

    // TODO CHECK IF WE WANT TO REMOVE ARROWS
    const arrows = document.querySelector(".main-image .scroll-buttons");
    if (arrows) {
      arrows.remove();
    }
    if (clickX < rect.width / 2) {
      goToPreviousImage();
    } else {
      // Right side: go to next image
      goToNextImage();
    }
  });
}
// DETECT IF HEADER HAS SCROLLED
const header = document.querySelector("header");
const sticky = 50;

const checkScroll = () => {
  if (window.pageYOffset > sticky) {
    header.classList.add("scrolled");
  } else {
    header.classList.remove("scrolled");
  }
};
checkScroll();

window.addEventListener("scroll", checkScroll);

class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector(
        'input[name="language_code"], input[name="country_code"]',
      ),
    };
    this.querySelectorAll("a").forEach((item) =>
      item.addEventListener("click", this.onItemClick.bind(this)),
    );
  }
  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector("form");
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }
}

customElements.define("localization-form", LocalizationForm);

const seeAllFaqsButtons = document.querySelectorAll(".see_all_faqs");

seeAllFaqsButtons.forEach((button) => {
  button.addEventListener("click", () => {
    button.nextElementSibling.classList.toggle("hide");
    button.remove();
  });
});

function getContrastColor(bgColor) {
  const rgb = bgColor.match(/\d+/g).map(Number);
  const luminance = (0.299 * rgb[0] + 0.587 * rgb[1] + 0.114 * rgb[2]) / 255;
  return luminance > 0.5 ? "#333" : "white";
}

// Example usage
// const el = document.querySelector(".dynamic-text");
// const bgColor = getComputedStyle(el).backgroundColor;
// el.style.color = getContrastColor(bgColor);

const allCocktailCards = document.querySelectorAll(".cocktail-card .back");
allCocktailCards.forEach((card) => {
  const bgColor = getComputedStyle(card).backgroundColor;
  card.style.color = getContrastColor(bgColor);
});

document.addEventListener("DOMContentLoaded", function () {
  const previousScrollPosition = localStorage.getItem("nona-scroll-position");
  if (previousScrollPosition) {
    window.scrollTo(0, parseInt(previousScrollPosition, 10));
    localStorage.removeItem("nona-scroll-position");
  }

  const videoBtn = document.getElementById("video-btn");
  const videoo = document.getElementById("videoo");

  if (videoBtn && videoo) {
    videoBtn.addEventListener("click", function () {
      videoo.classList.toggle("hide");
      if (!videoo.classList.contains("hide")) {
        videoo.play();
      } else {
        videoo.pause();
      }
    });
  }
});

const imageBlocks = document.querySelectorAll(".image-block:has(.image-2)");

imageBlocks.forEach((block) => {
  block.addEventListener("click", () => {
    block.classList.toggle("click");
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const fadeAnimation = () => {
    const previewImages = document.querySelectorAll(".medals-block img");
    if (previewImages) {
      previewImages.forEach((img, i) => {
        setTimeout(
          () => {
            img.style.transform = "scale(1.3)";
          },
          123 * (i + 1),
        );
      });
      previewImages.forEach((img, i) => {
        setTimeout(
          () => {
            img.style.transform = "scale(1)";
          },
          123 * (i + 2),
        );
      });
    }
  };
  const uuu = document.querySelector(".medals-block");

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          fadeAnimation();
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 1 },
  );
  if (uuu) {
    observer.observe(uuu);
  }
});
